<bdo-dashboard-tile
  [tileTitle]="'dashboard.paymentTile.title' | translate"
  [linkData]="[{linkName: !isInactive || payments?.offeneSumme ? ('dashboard.paymentTile.link' | translate) : '',
              href: '/zahlungen/' + customerStore.getAccountId(),
              tracking: [TRACKING.LOCATION.DASHBOARD, TRACKING.ACTION.GOTO, TRACKING.LOCATION.PAYMENTS]
  }]"
  >
  @if (payments?.next) {
    <div class="re-mb-default re-small">
      <div class="bold">{{ 'dashboard.paymentTile.nextPayment' | translate }}</div>
      <div class=" re-mb-default">{{ 'general.tariff.dueOn' | translate }} {{payments.nextDatum | date:'longDate' }}</div>
      <div class="bold bigger re-mb-default">{{payments.next | currency:'EUR'}}</div>
      @if (bankAccountAssignments) {
        <div>
          @if (bankAccountAssignments.debit) {
            <div>
              <div>{{ 'dashboard.banking.claimsWithSEPA' | translate }}</div>
              {{bankAccountAssignments.debit.bankname}}:&nbsp;{{bankAccountAssignments.debit.iban}}
            </div>
          } @else {
            {{ 'dashboard.banking.noBankAccountForNextPayment' | translate }}
          }
        </div>
      }
    </div>
  } @else {
    <div class="re-mb-default re-small">
    {{ 'dashboard.paymentTile.noOpenPayments' | translate }}</div>
  }
</bdo-dashboard-tile>
